<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <label>Nome</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="veiculo.nome"
                    id="nome"
                  />
                </div>
                <div class="col-md-3">
                  <label>Tipo de veiculo</label>
                  <v-select
                    :options="tipo_veiculo"
                    :reduce="(tipo_veiculo) => tipo_veiculo.id"
                    :label="'nome'"
                    v-model="veiculo.tipo_veiculo_id"
                  ></v-select>
                </div>
                <div class="col-md-3">
                  <label>Rota</label>
                  <v-select
                    :options="rotas"
                    :reduce="(rotas) => rotas.id"
                    :label="'nome'"
                    v-model="veiculo.rotas"
                  ></v-select>
                </div>
                <div class="col-md-12">
                  <label>Descrição</label>
                  <ckeditor
                    :editor="editor"
                    v-model="veiculo.descricao"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
                <div class="col-md-12 text-right">
                  <hr />
                  <router-link to="/veiculos" class="btn btn-back mr-1">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "imageUpload",
  data() {
    return {
      tipo_veiculo: [],
      veiculo: {},
      rotas: [],
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        language: "pt-br",
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "numberedlist",
          "bulletedlist",
          "|",
          "outdent",
          "indent",
          "|",
          "blockquote",
          "inserttable",
          "undo",
          "redo",
        ],
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "veiculos";

      self.$loading(true);

      if (self.veiculo.id) {
        api += "/" + self.veiculo.id;
        self.veiculo._method = "PUT";
      }

      axios
        .post(api, self.veiculo)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/veiculos");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getVeiculo: function (id) {
      const self = this;
      const api = self.$store.state.api + `veiculos/${id}?with[]=rotas`;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.veiculo = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRotas: function () {
      const self = this;
      const api = self.$store.state.api + "rotas?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.rotas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoVeiculo: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_veiculos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.tipo_veiculo = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRotaVeiculos: function (id) {
      const self = this;
      const api = self.$store.state.api + "rota_veiculos?veiculo_id=" + id;

      axios
        .get(api)
        .then((response) => {
          if (response.data.data.length > 0) {
            self.veiculo.rotas = [response.data.data[0].rota_id];
            self.$loading(false);
          } else {
            self.veiculo.rotas = [];
            self.$loading(false);
          }
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    $("#nome").focus();

    self.getRotas();
    self.getTipoVeiculo();

    let id = self.$route.params.id;
    if (id) {
      self.getVeiculo(id);
      self.getRotaVeiculos(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>